import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'

interface RecipientsTooltipProps {
  className?: string
  openLeft: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
}

const RecipientsTooltip: React.FC<RecipientsTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip
      className={props.className}
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
    >
      <p>
        <Trns
          source={
            'You can now enter or choose multiple recipients. Each recipient will receive their own copy of this virtual card, which you can manage independently.'
          }
        />
      </p>
    </Tooltip>
  )
}

export default RecipientsTooltip
